module.exports = __webpack_public_path__ + "static/media/road.b00875ee.jpg";